import React, { useState } from "react";
import "./App.css";
import ilu from "./assets/mi_ilu_25.png";

const API_BASE = "https://edith.moodi.org/api/rsvp";

function App() {
  const [name, setName] = useState("");
  const [rollNo, setRollNo] = useState("");
  const [ldapEmail, setLdapEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [passImage, setPassImage] = useState(null); // 🆕 base64 e-pass image
  const [showPassPopup, setShowPassPopup] = useState(false);

  function validateEmail(e) {
    return e.toLowerCase().trim().endsWith("@iitb.ac.in");
  }

  const handleSendOtp = async () => {
    setMessage("");
    if (!validateEmail(ldapEmail))
      return setMessage("LDAP email must end with @iitb.ac.in");
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/send_otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ldap_email: ldapEmail }),
      });
      const data = await res.json();
      if (res.ok) {
        setOtpSent(true);
        setMessage("OTP sent. Check your email.");
      } else {
        setMessage(data.message || "Failed to send OTP");
      }
    } catch (err) {
      console.error(err);
      setMessage("Network error");
    }
    setLoading(false);
  };

  const handleVerifyOtp = async () => {
    setMessage("");
    if (!otp) return setMessage("Enter OTP");
    if (!name) return setMessage("Enter your name before verifying");
    if (!rollNo) return setMessage("Enter your roll number");
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/verify_otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ldap_email: ldapEmail, otp, name, roll_no: rollNo }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage("OTP verified ✅ Registration complete!");
        if (data.passImage) {
          setPassImage(data.passImage);
          setShowPassPopup(true); // 🆕 Show popup
        }
      } else {
        setMessage(data.message || "Invalid OTP");
      }
    } catch (err) {
      console.error(err);
      setMessage("Network error");
    }
    setLoading(false);
  };

  const resetFlow = () => {
    setOtpSent(false);
    setOtp("");
    setPassImage(null);
    setShowPassPopup(false);
    setMessage("");
    setName("");
    setRollNo("");
    setLdapEmail("");
  };

  return (
    <div className="container">
      <div className="overlay"></div>
      <div className="inner-container">
        <img src={ilu} alt="Mood Indigo 25" className="ilu" />
        <div className="rsvp-form">
          <h1>MOOD INDIGO PRESENTS</h1>
          <h1>INSTI NITE RSVP PORTAL</h1>

          <div className="form">
            <label>Name</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Full name"
            />

            <label>Roll Number</label>
            <input
              value={rollNo}
              onChange={(e) => setRollNo(e.target.value)}
              placeholder="e.g. 22Bxxxx"
            />

            <label>LDAP Email (must end with iitb.ac.in)</label>
            <input
              value={ldapEmail}
              onChange={(e) => setLdapEmail(e.target.value)}
              placeholder="roll_number@iitb.ac.in"
            />

            {!otpSent && (
              <button className="btn" onClick={handleSendOtp} disabled={loading}>
                {loading ? "Sending..." : "Send OTP"}
              </button>
            )}

            {otpSent && (
              <>
                <label>Enter OTP</label>
                <input
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="6-digit OTP"
                />
                <div className="row">
                  <button className="btn" onClick={handleVerifyOtp} disabled={loading}>
                    {loading ? "Verifying..." : "Verify OTP"}
                  </button>
                  <button
                    className="btn muted"
                    onClick={() => {
                      setOtp("");
                      setMessage("");
                    }}
                  >
                    Clear OTP
                  </button>
                </div>
              </>
            )}
          </div>
        </div>

        {/* 🆕 Pass Popup Modal */}
        {showPassPopup && (
          <div className="popup-overlay" onClick={() => setShowPassPopup(false)}>
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
              <h2>Your Insti Nite E-Pass 🎟️</h2>
              <img
                src={passImage}
                alt="Insti Nite E-Pass"
              />
              <button className="btn" onClick={resetFlow} style={{ marginTop: "15px" }}>
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
